import { CaptionedContentElementData } from "@courses-pm2/api/src/ts/models/elements/CaptionedContentElementModel";

import { getMetaValue } from "@courses-pm2/api/src/ts/parser/getMetaValue";
import { parseContentElement } from "@courses-pm2/api/src/ts/parser/parseContentElement";

/**
 * Helper that parses the basic configurations of a captioned content element.
 */
export function parseCaptionedContentElement(
  node: Element
): Pick<
  CaptionedContentElementData,
  Exclude<keyof CaptionedContentElementData, "portalId">
> {
  // Extract caption content
  const caption = {
    authorOrArtist: getMetaValue(node, "Author"),
    description: getMetaValue(node, "Description"),
    label: getMetaValue(node, "Caption"),
    country: getMetaValue(node, "Country"),
    creditLine: getMetaValue(node, "CreditLine"),
    duration: getMetaValue(node, "Duration"),
    year: getMetaValue(node, "Year"),
    numberOfPages: getMetaValue(node, "NumberOfPages"),
  };

  const hasCaption =
    caption.authorOrArtist ||
    caption.description ||
    caption.label ||
    caption.country ||
    caption.creditLine ||
    caption.duration ||
    caption.year ||
    caption.numberOfPages;

  // Extract display configurations
  const displayCaptionAbove = node.getAttribute("textsOnTop") === "true";

  return {
    title: getMetaValue(node, "Title"),
    description: getMetaValue(node, "Description"),
    caption: hasCaption ? caption : undefined,
    displayCaptionAbove: displayCaptionAbove,
    displayCaptionBelow: !displayCaptionAbove,

    // Push basic content element configurations as well
    ...parseContentElement(node),
  };
}
